
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from 'react';
import { UIMixin } from "../../../mixins/uiMixin";
import { connect } from "react-redux";

class CashOutType extends Component {
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
const mapStateToProps = state => {
    return {
        user: state.user
    };
};
export default connect(mapStateToProps)(UIMixin({Component: CashOutType}));